(function (root, factory) {
  const api = factory(root);

  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.MinimogProductMediaLazy = api;
  }
})(typeof window !== "undefined" ? window : globalThis, function (root) {
  const defaultWidths = "375,550,750,900,1100,1500,1780,2000";
  const defaultMaxWidth = 2000;

  function parseWidths(widths, maxWidth, maxCandidateWidth) {
    const parsed = String(widths || defaultWidths)
      .split(",")
      .map((width) => parseInt(width, 10))
      .filter((width) => Number.isFinite(width) && width > 0);

    const intrinsicLimit = parseInt(maxWidth, 10);
    const configuredLimit = parseInt(maxCandidateWidth || defaultMaxWidth, 10);
    const limits = [intrinsicLimit, configuredLimit].filter((width) => Number.isFinite(width) && width > 0);
    const limit = limits.length ? Math.min(...limits) : null;
    const filtered = limit ? parsed.filter((width) => width <= limit) : parsed;

    if (limit && !filtered.includes(limit)) {
      filtered.push(limit);
    }

    return [...new Set(filtered)].sort((a, b) => a - b);
  }

  function replaceWidth(url, width) {
    const value = String(url || "");
    if (!value) return value;
    if (/[?&]width=\d+/.test(value)) {
      return value.replace(/([?&]width=)\d+/, "$1" + width);
    }
    return value + (value.includes("?") ? "&" : "?") + "width=" + width;
  }

  function buildImageAttributes(dataset) {
    const originalWidth = dataset.mediaOriginalWidth || dataset.mediaWidth;
    const widths = parseWidths(dataset.mediaSrcsetWidths, originalWidth, dataset.mediaSrcsetMaxWidth);
    const baseUrl = dataset.mediaSrcsetBase || dataset.mediaPreviewSrc || dataset.mediaSrc;
    const srcset = widths.map((width) => replaceWidth(baseUrl, width) + " " + width + "w").join(", ");

    return {
      src: dataset.mediaPreviewSrc || replaceWidth(baseUrl, widths[0]),
      srcset,
      sizes: dataset.mediaSizes || "100vw",
      loading: "lazy",
      decoding: "async",
      width: dataset.mediaWidth || dataset.mediaOriginalWidth || "",
      height: dataset.mediaHeight || "",
      alt: dataset.mediaAlt || "",
    };
  }

  function setAttributes(element, attrs) {
    Object.keys(attrs).forEach((name) => {
      if (attrs[name] !== undefined && attrs[name] !== null) {
        element.setAttribute(name, attrs[name]);
      }
    });
  }

  function hydrateMediaElement(mediaElement) {
    if (!mediaElement || !mediaElement.dataset) return false;
    if (mediaElement.dataset.mediaHydrated === "true") return true;
    if (mediaElement.dataset.mediaLazyHydrate !== "true") return false;

    const documentRef = mediaElement.ownerDocument || (root && root.document);
    if (!documentRef) return false;

    const attrs = buildImageAttributes(mediaElement.dataset);
    const image = documentRef.createElement("img");
    setAttributes(image, attrs);

    const responsiveImage = mediaElement.querySelector("responsive-image") || mediaElement;
    responsiveImage.querySelectorAll("[data-media-lazy-placeholder]").forEach((placeholder) => placeholder.remove());
    responsiveImage.appendChild(image);
    responsiveImage.classList && responsiveImage.classList.add("m-image-loaded");

    mediaElement.dataset.mediaHydrated = "true";
    mediaElement.removeAttribute("data-media-lazy-hydrate");

    return true;
  }

  function hydrateSlide(slide) {
    if (!slide || !slide.querySelectorAll) return false;
    let hydrated = false;
    slide.querySelectorAll(".m-product-media[data-media-lazy-hydrate='true']").forEach((mediaElement) => {
      hydrated = hydrateMediaElement(mediaElement) || hydrated;
    });
    return hydrated;
  }

  function getMediaIdFromSlide(slide) {
    if (!slide || !slide.querySelector) return "";
    const media = slide.querySelector(".m-product-media[data-media-id]");
    return media && media.dataset ? media.dataset.mediaId : "";
  }

  function hydrateMediaById(rootElement, mediaId) {
    if (!rootElement || !rootElement.querySelectorAll || !mediaId) return false;
    let hydrated = false;
    rootElement.querySelectorAll(".m-product-media[data-media-id]").forEach((mediaElement) => {
      if (mediaElement.dataset.mediaId === String(mediaId)) {
        hydrated = hydrateMediaElement(mediaElement) || hydrated;
      }
    });
    return hydrated;
  }

  function hydrateSlideAndMatching(rootElement, slide) {
    const mediaId = getMediaIdFromSlide(slide);
    const hydratedSlide = hydrateSlide(slide);
    const hydratedMatching = mediaId ? hydrateMediaById(rootElement, mediaId) : false;
    return hydratedSlide || hydratedMatching;
  }

  function hydrateSwiper(swiper, rootElement, radius) {
    if (!swiper || !swiper.slides || typeof swiper.activeIndex !== "number") return false;

    const range = Number.isFinite(radius) ? radius : 2;
    const start = Math.max(0, swiper.activeIndex - range);
    const end = Math.min(swiper.slides.length - 1, swiper.activeIndex + range);
    let hydrated = false;

    for (let index = start; index <= end; index += 1) {
      hydrated = hydrateSlideAndMatching(rootElement, swiper.slides[index]) || hydrated;
    }

    return hydrated;
  }

  return {
    buildImageAttributes,
    hydrateMediaElement,
    hydrateMediaById,
    hydrateSlide,
    hydrateSlideAndMatching,
    hydrateSwiper,
    replaceWidth,
  };
});
